import { createApp } from 'vue'
import App from './App.vue'
import router from "@/router/router";
import store from '@/store';
import { VueMaskDirective } from 'v-mask';
import i18n from './locales/i18n';
import VueGtag from "vue-gtag";
import { MonthPicker } from 'vue-month-picker'
import { MonthPickerInput } from 'vue-month-picker'

const vMaskV2 = VueMaskDirective;
const vMaskV3 = {
    beforeMount: vMaskV2.bind,
    updated: vMaskV2.componentUpdated,
    unmounted: vMaskV2.unbind
};
// import axios from "axios";
// import './api/axios'

// const accessToken = localStorage.getItem('access-token')
// if (accessToken) {
//   axios.defaults.headers.common['Authorization'] = accessToken
// }


const app = createApp(App)
app.directive('mask', vMaskV3)
app.use(VueGtag, {
    config: {id: "G-4Z9PKTXC3M"}
})
app.use(MonthPicker)
app.use(MonthPickerInput)
app.use(router).use(store).use(i18n).mount('#app');
